module.exports = __webpack_public_path__ + "img/delete_content.176494a8.svg";